/* lua.js generated code 0.3.0 */


let CoinMatchManager = require("activity/CoinMatchActivity/CoinMatchManager")
require("clover/config/level/LevelConfig")

LevelConfigManager = xClass("LevelConfigManager")
const CFG_CACHE_LIMIT = 3; // 最大缓存的关卡配置数
const CFG_RECENT_LIMIT = 2; // 最大缓存的近期获取关卡数 可能会加载新关卡时候还要读到前一个，需要缓存
LevelConfigManager.prototype.ctor = function () {
    var self = this
    self.levelConfigs = table()
    self.hiddenNodeRange = 10000
    self.levelDigest = null
    self.allStars = null
    self.allOrangeStars = null
    self.allBlueStars = null
    self.maxLevelWithConfig = 0

    self.cfgGetFreq = {}
    self.cfgRecent = []
}

function addToCfgRecent(cfgRecent, lvId) {
    if (!lvId)
        return;
    let index = cfgRecent.indexOf(lvId.toString())
    if (index >= 0) {
        if (index !== cfgRecent.length - 1) {
            cfgRecent.splice(index, 1);
            cfgRecent.push(lvId.toString());
        }
    } else {
        if (cfgRecent.length == CFG_RECENT_LIMIT) {
            cfgRecent.splice(0, 1);
        }
        cfgRecent.push(lvId.toString());
    }
}
LevelConfigManager.prototype.replaceLevelID = function (id, targetId){
    var self = this
    let value = self.levelConfigs[id]
    if (value != null){
        value.originalLvlId = id //for dc
        self.levelConfigs[targetId] = value
        delete self.levelConfigs[id];

        if (self.cfgGetFreq[id] != null) {
            self.cfgGetFreq[targetId] = self.cfgGetFreq[id];
            delete self.cfgGetFreq[id];
            addToCfgRecent(self.cfgRecent, targetId);
        }
    }
}

// 获取解析过后的关卡配置 LevelConfig
LevelConfigManager.prototype.getLevelConfigByID = function (id, reload, otherData) {
    var self = this
    if (!id)
        return null;

    if (LevelType.isMysteryIslandLevel(id)) {
        // let MysteryIslandManager = require("clover/data/MysteryIslandManager")
        // WARN: maybe multi result
        return self.getLevelConfigByID(MysteryIslandManager.getInstance().calculateMainLevelId(id), reload,{
            isMysteryIslandLevel: true
        })
    }
    // 增加获取配置次数
    let freq = self.cfgGetFreq[id];
    self.cfgGetFreq[id] = freq? freq + 1: 1;
    addToCfgRecent(self.cfgRecent, id);

    // 是否是友谊赛
    if (otherData && otherData.isFriendPvp){
        self.isFriendPvp = otherData.isFriendPvp;
    }else{
        self.isFriendPvp = false;
    }

    if (reload) {
        self.levelConfigs[id] = null
    }
    if (!self.levelConfigs[id]) {
        var cfg = self.createLevelConfig(id)
        self.levelConfigs[id] = cfg

        self.checkCfgCacheLimit(id);
    }

    let config = clone(self.levelConfigs[id])
    // 如果是iaa重定义关卡步数配置
    if (UserManager.getInstance().isUseIAA() && UserManager.getInstance().isIaaPassTopLevel()
    && (!otherData || !otherData.isMysteryIslandLevel)){
        let levelMeta = self.getLevelDigest(id)
        try {
            let mArr = levelMeta.moveLimitArr
            cc.log("[iaa] getLevelConfigByID mArr ",mArr)
            if(mArr){
                let mNum = UserManager.getInstance().getGroupByModule("iaa_step") == "b" ? mArr[1] : mArr[0]
                cc.log("[iaa] getLevelConfigByID mNum ",mNum)
                if (mNum > 10 || mNum < -10){
                    mNum = mNum > 10 ? 10 : mNum
                    mNum = mNum < -10 ? -10 : mNum
                    cc.log("[iaa] getLevelConfigByID fix mNum ",mNum)

                    let errorStr = levelMeta.moveLimitModify || ""
                    window.logCenter && logCenter.error(new Error("moveLimitModify:"+errorStr), 'IaaFixStepError')
                }
                config.moveLimit += tonumber(mNum)
            }
        } catch (error) {
            cc.error("错误的配置信息",error,levelMeta.moveLimitModify,levelMeta.moveLimitArr)
        }
        // config.moveLimitModify
    }
    if (LevelType.getLevelTypeByLevelId(id) === GameLevelType.kCoinMatch) {
        config.moveLimit =  CoinMatchManager.getInstance().getLeftStep()
    } else if (LevelType.getLevelTypeByLevelId(id) === GamePlayType.kTimeBlockCollection) {
        let info = TimeModeActivityManager.getInstance().getInfo()
        config.moveLimit = 0
        config.timeLimit = info.timeLimit
        config.targetNumThreshold = info.targetThreshold
        config.extraAddTime = info.nextLevelAddTime
        config.gameMode = GamePlayType.kTimeBlockCollection
        config.shareJudgeTime = info.shareJudgeTime
        config.shareAddTime = info.shareAddTime
        config.shareLimit = info.shareLimit
        config.shareCount = info.shareCount
        config.adLimit = info.adLimit
        config.todayAdCount = info.todayAdCount
    }else if (otherData && otherData.isMysteryIslandLevel){
        config.moveLimit = config.moveLimit - MysteryIslandManager.getInstance().getLevelInfo().deductStepNum
    }
    return config
}
LevelConfigManager.prototype.getGameplayLevelConfigByID = function (id, reload, userStar) {
    var self = this

    var config = self.getLevelConfigByID(id, reload)
    if (!config) {
        return null
    }
    var ret = clone(config)
    return LevelConfigManager.buildStar(ret, userStar)
}

LevelConfigManager.prototype.getGameplayLevelDigestConfigByID = function (id, reload, userStar) {
    var self = this

    var config = self.getLevelDigest(id, reload)
    if (!config) {
        return null
    }
    var ret = clone(config)
    return LevelConfigManager.buildStar(ret, userStar)
}

// @id 关卡的id
// @cfgFile fullpath of *.inf
// @return content of *.inf
// 方法主要给check用
LevelConfigManager.prototype.getLevelConfigFromFile = function (id, cfgFile) {
    let self = this
    if (cc.FileUtils.getInstance().isFileExist(cfgFile)) {
        let path = cc.FileUtils.getInstance().fullPathForFilename(cfgFile)
        let data = he.HeFileUtils.decodeFile(path)
        let cfg = self.updateLevelConfig(id, data)
        return cfg
    }
    return null
}

let abTestLevel = []
LevelConfigManager.prototype.getLevelConfigPath = function (id,isMystery) {
    let self = this
    let prefix = 'meta/level/'
    // if (LevelType.getLevelTypeByLevelId(id) === GameLevelType.kPvp) {
    //     id -= LevelConstans.PVP_LEVEL_ID_S
    // }else {
        // if (abTestLevel.indexOf(id) >= 0 && UserManager.getInstance().isTestGroup()) {
        //     prefix = 'meta/levelAB/'
        // }
    // }
    // 处于测试分组 且当前关卡为测试关卡  要排除神秘岛情况(神秘岛没有实际关卡用的是普通关卡资源文件)
    if(!isMystery && self.isLevelB(id)){
        cc.log("[LevelAB] getLevelConfigPath B组 ",id)
        prefix = 'meta/levelB/'
    }
    return prefix + id + '.json'
}

LevelConfigManager.prototype.createLevelConfig = function (id) {
    var self = this
    var path = this.getLevelConfigPath(id)
    printf("create level config with file:%s", path)
    var config = cc.loader.getRes(path)
    if (!config) {
        throw new Error(`${path} is not loaded`)
        // cc.warn(`${path} is not loaded`)
    }
    var gameModeInPvp = null;
    if (LevelType.getLevelTypeByLevelId(id) === GameLevelType.kPvp) {
        gameModeInPvp = config.gameMode; // 友谊赛实际游戏模式，等待结算的时候需要显示用
        config.gameMode = GamePlayType.kPvp
        config.gameModeInPvp = gameModeInPvp; // 友谊赛不再用pvpMapData，用实际游戏模式来加载再加上pvp的资源
    }
    if (LevelType.getLevelTypeByLevelId(id) === GameLevelType.kOneStep) {
        config.gameMode = GamePlayType.kOneStep
    }
    if (LevelType.getLevelTypeByLevelId(id) === GameLevelType.kCoinMatch) {
        config.moveLimit =  CoinMatchManager.getInstance().getLeftStep()
    }
    if (self.isFriendPvp){
        config.isFriendPvp = self.isFriendPvp; // 友谊赛
    }
    var cfg = self.updateLevelConfig(id, config)
    if (gameModeInPvp && self.isFriendPvp){
        cfg.gameModeInPvp = gameModeInPvp;
    }
    return cfg
}

LevelConfigManager.buildStar = function (ret, userStar) {
    // FIXME: 此处临时修复由clone不完全导致的问题，待有时间一起解决
    ret.scoreTargets = $table(ret.scoreTargets)
    // if (userStar < 3) {
    //     while ($len(ret.scoreTargets) > 3) {
    //         table.remove(ret.scoreTargets)
    //     }
    // } else if (userStar < 4) {
    //     while ($len(ret.scoreTargets) > 4) {
    //         table.remove(ret.scoreTargets)
    //     }
    // } else if (userStar < 5) {
    //     while ($len(ret.scoreTargets) > 5) {
    //         table.remove(ret.scoreTargets)
    //     }
    // }
    return ret
}

LevelConfigManager.prototype.updateLevelConfig = function (id, data) {
    var self = this
    if (data) {
        var cfg = LevelConfig.create()
        cfg.initWithData(id, data)
        self.levelConfigs[id] = cfg
        self.checkCfgCacheLimit(id);
        return cfg
    } else {
        return null
    }
}
LevelConfigManager.prototype.getLevelGameMode = function (levelId) {
    var self = this
    if (levelId === 0) {
        return 0
    }
    var levelMeta = self.getLevelDigest(levelId)
    if (levelMeta) {
        return levelMeta.gameMode
    } else if (LevelType.getLevelTypeByLevelId(levelId) === GameLevelType.kPvp) {
        return GamePlayType.kPvp
    } else if (LevelType.getLevelTypeByLevelId(levelId) === GameLevelType.kOneStep) {
        return GamePlayType.kOneStep
    } else if (LevelType.isMysteryIslandLevel(levelId)) {
        // let MysteryIslandManager = require("clover/data/MysteryIslandManager")
        return self.getLevelGameMode(MysteryIslandManager.getInstance().calculateMainLevelId(levelId))
    }
    return null
}


LevelConfigManager.prototype.getBossCountByLevelId = function (levelId) {
    var self = this
    if (levelId < 1) {
        return 0
    }
    var totalCount = 0
    var $limit20 = levelId
    for (var i = 1; i <= $limit20; i += 1) {
        var levelMode = self.getLevelGameMode(i)
        if (levelMode === GamePlayType.kBoss) {
            totalCount = totalCount + 1
        }
    }
    return totalCount
}

LevelConfigManager.prototype.loadWeeklyLevelConfig = function(func) {}

LevelConfigManager.prototype.getLevelDigest = function (levelID) {
    var self = this
    if (!self.levelDigest) {
        let configPath = UserManager.getInstance().isLevelTestGroup() ? "meta/level_digestB.json" : "meta/level_digest.json"
        //  读取配置文件
        self.levelDigest = cc.loader.getRes(configPath)
        unloadResList(configPath);
        //  读取配置文件
        self.levelExtend = CfgManager.get("level_extend");
        for (let i in self.levelExtend) {
            if(self.levelDigest[i]){
                if (UserManager.getInstance().isLevelTestGroup()){
                    self.levelDigest[i].isHardLevel = self.levelExtend[i].hardlevelB == 1 ? true : false
                    self.levelDigest[i].moveLimitModify = self.levelExtend[i].moveLimitModifyB
                }else{
                    self.levelDigest[i].isHardLevel = self.levelExtend[i].hardlevel == 1 ? true : false
                    self.levelDigest[i].moveLimitModify = self.levelExtend[i].moveLimitModify
                }
                if (self.levelDigest[i].moveLimitModify){
                    self.levelDigest[i].moveLimitArr = self.levelDigest[i].moveLimitModify.split(",")
                }
                self.levelDigest[i].loading_id = self.levelExtend[i].loading_id > 0 ? self.levelExtend[i].loading_id : null
                self.levelDigest[i].loading_time = self.levelExtend[i].loading_time > 0 ? self.levelExtend[i].loading_time : null
                
            }
        }
    }
    if (LevelType.isMysteryIslandLevel(levelID))
    {
        let levelIDNew = MysteryIslandManager.getInstance().calculateMainLevelId(levelID)
        let conf = clone(self.levelDigest[tostring(levelIDNew)]) 
        conf.isHardLevel = false
        return conf
    }else{
        return self.levelDigest[tostring(levelID)]
    }
}
// 是否是测试关卡
LevelConfigManager.prototype.isLevelB = function (levelID) {
    let self = this
    let conf = self.getLevelDigest(levelID)
    if (conf){
        return conf.level_group == "B"
    }
    return false
}
LevelConfigManager.prototype.getMaxMainLevelId = function () {
    var self = this
    var maxLevelId = 0
    for (var k in self.levelDigest) {
        var v = self.levelDigest[k]
        var level = tonumber(k)
        if (LevelType.isMainLevel(level) && level > maxLevelId) {
            maxLevelId = level
        }
    }
    return maxLevelId
}
LevelConfigManager.prototype.getTotalStars = function () {
    var self = this
    if (!self.levelDigest) {
        self.getLevelDigest(1)
    }
    if (self.allStars) {
        return self.allStars
    }
    self.allStars = 0
    self.allOrangeStars = 0
    self.allBlueStars = 0

    let maxLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
    for (var k in self.levelDigest) {
        var v = self.levelDigest[k]
        k = tonumber(k)
        //        if (LevelConfigManager.getInstance().getLevelConfigByID(k)) {
        var bool = true
        if (k > maxLevel || LevelType.isHideLevel(k)) {
            bool = false
        } else if (LevelType.isMainLevel(k)) {
            self.maxLevelWithConfig = Math.max(self.maxLevelWithConfig, k)
        } else {
            bool = false
        }
        if (bool && type(v) === "table" && type(v.scoreTargets) === "table") {
            self.allStars = self.allStars + $len(v.scoreTargets)
            if ($len(v.scoreTargets) >= 3) {
                self.allOrangeStars = self.allOrangeStars + 1
            }
            if ($len(v.scoreTargets) >= 4) {
                self.allBlueStars = self.allBlueStars + 1
            }
        }
    }
    //    }
    return self.allStars
}
LevelConfigManager.prototype.getMaxLevelWithConfig = function () {
    var self = this
    self.getTotalStars()
    return self.maxLevelWithConfig
}
/**
 * 获取指定关卡的困难关信息
 */
LevelConfigManager.prototype.getHardLevel = function (levelId) {
    var self = this
    if (levelId) {
        if (LevelType.isMysteryIslandLevel(levelId)) {
            levelId = MysteryIslandManager.getInstance().calculateMainLevelId(levelId)
        }
        if (self.getLevelDigest(levelId).isHardLevel) {
            return true
        } else {
            return false
        }
    }
    return false
}

/**
 *  检查当前缓存数是否超上限
 * 超过上限保留请求频次最高的${CFG_CACHE_LIMIT}条配置
 */
LevelConfigManager.prototype.checkCfgCacheLimit = function(keepId) {
    let self = this;
    let keys = Object.keys(self.levelConfigs);
    if (keys.length > CFG_CACHE_LIMIT) {
        let newLevelConfigs = {}, remain = CFG_CACHE_LIMIT;
        
        // 保留KeepId
        if (keepId != null && self.levelConfigs[keepId] && !newLevelConfigs[keepId]) {
            newLevelConfigs[keepId] = self.levelConfigs[keepId];
            remain--;
        }
        
        // 保留近期CFG_RECENT_LIMIT个加载的
        if (remain > 0) {
            self.cfgRecent.forEach(lvId=> {
                if (lvId != keepId && self.levelConfigs[lvId] && !newLevelConfigs[lvId]) {
                    newLevelConfigs[lvId] = self.levelConfigs[lvId];
                    remain--;
                }
            })
        }

        // 按批次保留
        if (remain > 0) { 
            let ary = Array.from(Object.keys(self.cfgGetFreq), lvId=> {
                return {lvId: lvId, freq: (self.cfgGetFreq[lvId] || 0)}
            });
            ary.sort((a, b)=> b.freq - a.freq);

            for(let i = 0, lvId = ary[i].lvId; i < ary.length; i++, lvId = ary[i].lvId) {
                if (lvId != keepId && self.levelConfigs[lvId] && !newLevelConfigs[lvId]) {
                    newLevelConfigs[lvId] = self.levelConfigs[lvId];
                    remain--;

                    if (remain <= 0)
                        break;
                }
            }
        }
        self.levelConfigs = newLevelConfigs;
    }
}

var ldm__ = null
LevelConfigManager.getInstance = function () {
    if (!ldm__) {
        ldm__ = LevelConfigManager.new()
    }
    return ldm__
}
